/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * BankAccount without TransferFeeCondition
 * @export
 * @interface GetBankTransfer200ResponseSourceBankAccount
 */
export interface GetBankTransfer200ResponseSourceBankAccount {
    /**
     * 
     * @type {string}
     * @memberof GetBankTransfer200ResponseSourceBankAccount
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetBankTransfer200ResponseSourceBankAccount
     */
    'bankNumber': string;
    /**
     * 
     * @type {string}
     * @memberof GetBankTransfer200ResponseSourceBankAccount
     */
    'bankName': string;
    /**
     * 
     * @type {string}
     * @memberof GetBankTransfer200ResponseSourceBankAccount
     */
    'branchNumber': string;
    /**
     * 
     * @type {string}
     * @memberof GetBankTransfer200ResponseSourceBankAccount
     */
    'branchName': string;
    /**
     * 
     * @type {string}
     * @memberof GetBankTransfer200ResponseSourceBankAccount
     */
    'accountType': GetBankTransfer200ResponseSourceBankAccountAccountTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetBankTransfer200ResponseSourceBankAccount
     */
    'accountNumber': string;
    /**
     * 
     * @type {string}
     * @memberof GetBankTransfer200ResponseSourceBankAccount
     */
    'companyCode': string;
    /**
     * 
     * @type {string}
     * @memberof GetBankTransfer200ResponseSourceBankAccount
     */
    'companyName': string;
}

export const GetBankTransfer200ResponseSourceBankAccountAccountTypeEnum = {
    savingsAccount: 'SAVINGS_ACCOUNT',
    currentAccount: 'CURRENT_ACCOUNT',
    thriftAccount: 'THRIFT_ACCOUNT',
    other: 'OTHER'
} as const;

export type GetBankTransfer200ResponseSourceBankAccountAccountTypeEnum = typeof GetBankTransfer200ResponseSourceBankAccountAccountTypeEnum[keyof typeof GetBankTransfer200ResponseSourceBankAccountAccountTypeEnum];


